import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Add Google site verification meta tag
const googleVerification = document.createElement('meta');
googleVerification.setAttribute('name', 'google-site-verification');
googleVerification.setAttribute('content', 'jU04a1kPKEaeRY5AVx9gK6FUNR-gBdxLYRR9rvBgst4');
document.head.appendChild(googleVerification);
render(<App data-id="element-465" />, document.getElementById('root'));